export default __webpack_public_path__ + "static/logo9-be8fed84329d1b866b1f82ccb791b918.svg";